// 测试模板配置
export const testTemplates = {
  ACCOUNT_CREATE: {
    label: '开户',
    channelSpecific: true, // 标记为渠道特定配置
    channels: {
      EQUALS_MONEY: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'firstName', label: '名', type: 'input', required: true, group: 'extParam', tip: 'tipBusinessName' },
        { name: 'middleName', label: '中间名', type: 'input', group: 'extParam' },
        { name: 'lastName', label: '姓', type: 'input', required: true, group: 'extParam', tip: 'tipBusinessName' },
        { name: 'phone', label: '手机号', type: 'input', required: true, group: 'extParam', placeholder: '+8613800138000' },
        { name: 'dob', label: '生日', type: 'date', required: true, group: 'extParam', format: 'YYYY-MM-DD' },
        { name: 'email', label: '邮箱', type: 'input', required: true, group: 'extParam', placeholder: 'user@example.com' },
      ],
      SGB: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'fullName', label: '全名', type: 'input', required: true, group: 'extParam', placeholder: 'Zhang Qiang' },
        { name: 'dob', label: '生日/注册日期', type: 'input', required: true, group: 'extParam', placeholder: '31011990', tip: 'tipDobFormat' },
        { name: 'idType', label: '证件类型', type: 'select', required: true, group: 'extParam', options: ['P', 'N'], tip: 'tipIdType' },
        { name: 'idNumber', label: '证件号', type: 'input', required: true, group: 'extParam', placeholder: 'A123456789' },
        { name: 'nationality', label: '国籍', type: 'input', required: true, group: 'extParam', placeholder: 'CHN', tip: 'tip3LetterCountry' },
        { name: 'residenceCountry', label: '居住国/注册国', type: 'input', required: true, group: 'extParam', placeholder: 'CHN', tip: 'tip3LetterCountry' },
        { name: 'residenceCity', label: '居住城市/注册城市', type: 'input', required: true, group: 'extParam', placeholder: 'Beijing' },
        { name: 'residenceAddress', label: '居住地址/注册地址', type: 'input', required: true, group: 'extParam', placeholder: 'No. 123, Chaoyang Rd' },
        { name: 'corporateType', label: '企业类型', type: 'select', group: 'extParam', options: ['FI', 'NON_FI'], tip: 'tipCorporateType' },
      ],
      LEAN_TECH: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'fullName', label: '全名', type: 'input', required: true, group: 'extParam', placeholder: 'Zhang Qiang' },
        { name: 'bankIdentifier', label: '银行标识', type: 'input', required: true, group: 'extParam', placeholder: 'BANK123456', tip: 'tipBankIdentifierFromCard' },
        { name: 'callbackUrl', label: '回调地址', type: 'input', required: true, group: 'extParam', default: 'https://example.com/callback' },
      ],
      KORAPAY: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'virtualAccountName', label: '虚拟账户名', type: 'input', required: true, group: 'extParam', placeholder: 'Custom VA Name', tip: 'tipVirtualAccountName' },
        { name: 'bankIdentifier', label: '银行标识', type: 'input', required: true, group: 'extParam', placeholder: '000', tip: 'tipBankIdentifierFromCard' },
        { name: 'fullName', label: '用户名字', type: 'input', required: true, group: 'extParam', placeholder: 'User Full Name', tip: 'tipKycKybName' },
        { name: 'email', label: '邮箱', type: 'input', group: 'extParam', placeholder: 'user@example.com' },
        { name: 'ninNumber', label: 'NIN号码', type: 'input', group: 'extParam', placeholder: '12345678901', tip: 'tipNinNumber' },
        { name: 'bvnNumber', label: 'BVN号码', type: 'input', required: true, group: 'extParam', placeholder: '09876543211', tip: 'tipBvnNumber' },
      ],
      DURIANPAY: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT'] },
        { name: 'fullName', label: '用户全名', type: 'input', required: false, group: 'extParam', placeholder: 'Zhang Qiang', tip: 'tipVaDisplayName' },
        { name: 'virtualAccountName', label: 'VA账户名', type: 'input', required: true, group: 'extParam', placeholder: 'Custom VA Name' },
        { name: 'bankIdentifier', label: '银行标识', type: 'select', required: true, group: 'extParam', options: ['BRI', 'BCA', 'MANDIRI', 'PERMATA', 'CIMB', 'BNI', 'NOBU'] },
        { name: 'email', label: '邮箱', type: 'input', group: 'extParam', placeholder: 'user@example.com', tip: 'tipEmailOrMobile' },
        { name: 'mobile', label: '手机号', type: 'input', group: 'extParam', placeholder: '+6281234567890', tip: 'tipEmailOrMobile' },
      ],
      BANK_FRICK: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'fullName', label: '全名', type: 'input', required: true, group: 'extParam', placeholder: 'Zhang Qiang' },
        { name: 'country', label: '国家', type: 'input', required: true, group: 'extParam', placeholder: 'US' },
        { name: 'city', label: '城市', type: 'input', required: true, group: 'extParam', placeholder: 'Noke' },
        { name: 'street', label: '街道', type: 'input', required: true, group: 'extParam', placeholder: 'test address' },
        { name: 'number', label: '门牌号', type: 'input', required: true, group: 'extParam', placeholder: '1302-13' },
        { name: 'postalCode', label: '邮编', type: 'input', required: true, group: 'extParam', placeholder: '203220' },
      ],
      BANKING_CIRCLE: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'PIX', 'VIETQR', 'ZEN_WALLET', 'INTERACE_REQUEST', 'LEAN'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', required: true, group: 'extParam', default: 'https://example.com/callback' },
      ],
      BITSO: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT'], tip: 'tipBitsoVirtualAccount' },
      ],
      INSWITCH: [
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'paymentMethod', label: '支付方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT'], tip: 'tipInswitchVirtualAccount' },
        { name: 'documentType', label: '证件类型', type: 'select', required: true, group: 'extParam', options: ['CPF', 'CNPJ'], tip: 'tipInswitchIdType' },
        { name: 'documentNumber', label: '证件号', type: 'input', required: true, group: 'extParam', placeholder: 'CPF: 11位纯数字 / CNPJ: 14位纯数字', tip: 'tipInswitchDocNumber' },
        { name: 'firstName', label: '名', type: 'input', required: true, group: 'extParam', showWhen: { field: 'userType', value: 'INDIVIDUAL' }, tip: 'tipInswitchNameRule' },
        { name: 'lastName', label: '姓', type: 'input', required: true, group: 'extParam', showWhen: { field: 'userType', value: 'INDIVIDUAL' }, tip: 'tipInswitchNameRule' },
        { name: 'secondLastname', label: '第二姓', type: 'input', group: 'extParam', showWhen: { field: 'userType', value: 'INDIVIDUAL' }, tip: 'tipInswitchSecondLastname' },
        { name: 'birthDate', label: '出生日期/注册日期', type: 'input', required: true, group: 'extParam', placeholder: 'YYYY-MM-DD', tip: 'tipInswitchBirthDate' },
        { name: 'birthCountry', label: '出生国家/注册国', type: 'input', required: true, group: 'extParam', placeholder: 'BR', tip: 'tipInswitchCountryCode2' },
        { name: 'address', label: '地址', type: 'input', required: true, group: 'extParam', placeholder: 'Rua Example 123', tip: 'tipInswitchAddress' },
        { name: 'city', label: '城市', type: 'input', required: true, group: 'extParam', placeholder: 'São Paulo' },
        { name: 'countryCode', label: '国家代码', type: 'input', required: true, group: 'extParam', placeholder: 'BR', tip: 'tipInswitchCountryCode2' },
        { name: 'email', label: '邮箱', type: 'input', group: 'extParam', placeholder: 'user@example.com', tip: 'tipInswitchEmail' },
        { name: 'phoneNumber', label: '手机号', type: 'input', group: 'extParam', placeholder: '11999887766', tip: 'tipInswitchPhone' },
        { name: 'companyName', label: '公司名称', type: 'input', required: true, group: 'extParam', tip: 'tipInswitchCompanyName', showWhen: { field: 'userType', value: 'BUSINESS' } },
        { name: 'companyType', label: '公司类型', type: 'select', required: true, group: 'extParam', options: ['Professional Services and Consulting', 'Technology and Digital Platforms', 'Commerce, Import/Export, and E-commerce', 'Logistics, Transportation, and Related Services', 'Education, Entertainment, and Miscellaneous Services', 'Financial Transactions and Investments'], tip: 'tipInswitchCompanyType', showWhen: { field: 'userType', value: 'BUSINESS' } },
      ],
    },
    fields: [] // 通用字段为空，使用渠道特定配置
  },
  PAYIN: {
    label: '充值',
    channelSpecific: true,
    channels: {
      DURIANPAY: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true, default: () => `EXT_ORD_${Date.now()}` },
        { name: 'amount', label: '金额(IDR)', type: 'number', required: true },
        { name: 'depositMethod', label: '充值方式', type: 'select', required: true, options: ['QRIS', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'mobile', label: '手机号', type: 'input', group: 'extParam', placeholder: '62xxxxxxxxxx 或 08xxxxxxxxxx', tip: 'tipDurianPayMobile', requiredWhen: { field: 'depositMethod', value: 'OVO' } },
        { name: 'redirectUrl', label: '支付成功跳转URL', type: 'input', group: 'extParam', placeholder: 'https://merchant.com/success' },
        { name: 'expiryDate', label: '订单过期时间', type: 'input', group: 'extParam', placeholder: '2025-12-31T23:59:59+07:00', tip: 'tipDurianPayExpiryDate' },
      ],
      CHECKOUT: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true, default: () => `EXT_ORD_${Date.now()}` },
        { name: 'amount', label: '金额', type: 'number', required: true },
        { name: 'depositMethod', label: '充值方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'BANK_TRANSFER', 'PIX', 'IDEAL'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'successUrl', label: '成功跳转URL', type: 'input', required: true, group: 'extParam', placeholder: 'https://merchant.com/success' },
        { name: 'failureUrl', label: '失败跳转URL', type: 'input', required: true, group: 'extParam', placeholder: 'https://merchant.com/failure' },
        { name: 'description', label: '描述', type: 'input', required: true, group: 'extParam', placeholder: 'Payment description' },
        { name: 'language', label: '语言', type: 'input', required: true, group: 'extParam', placeholder: 'en' },
      ],
    },
    fields: [
      { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true, default: () => `EXT_ORD_${Date.now()}` },
      { name: 'amount', label: '金额', type: 'number', required: true },
      { name: 'depositMethod', label: '充值方式', type: 'select', required: true, options: ['VIRTUAL_ACCOUNT', 'BANK_TRANSFER', 'PIX'] },
      { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
      { name: 'accountId', label: '账户ID', type: 'input', group: 'extParam' },
    ]
  },
  PAYOUT: {
    label: '提现',
    channelSpecific: true,
    channels: {
      DURIANPAY: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额(IDR)', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: false, group: 'extParam', tip: 'tipDurianPayRecipientIdBankTransfer', requiredWhen: { field: 'withdrawMethod', value: 'BANK_TRANSFER' } },
        { name: 'mobile', label: '手机号', type: 'input', required: false, group: 'extParam', placeholder: '62xxxxxxxxxx 或 08xxxxxxxxxx', tip: 'tipDurianPayMobileWallet', requiredWhenNot: { field: 'withdrawMethod', value: 'BANK_TRANSFER' } },
      ],
      EQUALS_MONEY: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: 'tipRecipientIdFromPayment' },
      ],
      SGB: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: 'tipRecipientIdFromBind' },
        { name: 'purpose', label: 'Purpose', type: 'input', required: true, group: 'extParam', placeholder: 'SAL', tip: 'tipPurposeLength3' },
      ],
      BANKING_CIRCLE: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: 'tipRecipientIdFromPayment' },
      ],
      KORAPAY: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam' },
        { name: 'name', label: '用户名字', type: 'input', required: true, group: 'extParam', placeholder: 'John Doe' },
        { name: 'email', label: '用户邮箱', type: 'input', required: true, group: 'extParam', placeholder: 'john@example.com' },
      ],
      LEAN_TECH: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: 'tipRecipientIdFromBind' },
        { name: 'description', label: '转账描述', type: 'input', required: true, group: 'extParam', placeholder: 'withdraw description', tip: 'tipDescriptionMax32' },
      ],
      PYVIO: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam' },
        { name: 'targetCurrency', label: '目标币种', type: 'input', required: true, group: 'extParam', placeholder: 'EUR' },
        { name: 'targetAmount', label: '目标金额', type: 'input', required: true, group: 'extParam', placeholder: '1000.00' },
        { name: 'calOrigin', label: '计算方向', type: 'select', required: true, group: 'extParam', options: ['TARGET2ORIGIN', 'ORIGIN2TARGET'], tip: 'tipCalOrigin' },
        { name: 'purpose', label: 'Purpose', type: 'select', required: true, group: 'extParam', options: ['Professional Service', 'IT Service', 'TAX', 'Education/Training', 'Logistic', 'Warehouse', 'Advertisement', 'Airline', 'Salary', 'Pay to Associated Entity', 'Purchasing', 'Other'] },
        { name: 'rateId', label: 'Rate ID', type: 'input', group: 'extParam', tip: 'tipRateId' },
        { name: 'description', label: '转账备注', type: 'input', group: 'extParam', tip: 'tipDescriptionMax100' },
        { name: 'pobo', label: 'POBO', type: 'select', group: 'extParam', options: ['Y'], tip: 'tipPobo' },
      ],
      BANK_FRICK: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam' },
        { name: 'purpose', label: 'Purpose', type: 'select', required: true, group: 'extParam', options: ['POGD', 'POSV', 'PFEE', 'PERS', 'LODP', 'BILL', 'RNDV', 'BVEN', 'ICPY', 'CHDN', 'PROP', 'ESTH', 'GOVP', 'INVP', 'LIQM'] },
        { name: 'chargeType', label: '手续费承担', type: 'select', required: true, group: 'extParam', options: ['BEN', 'OUR', 'SHA'], tip: 'tipChargeType' },
      ],
      BITSO: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER'], tip: 'tipBitsoWithdrawMethod' },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: 'tipRecipientIdFromBind' },
        { name: 'rfc', label: 'RFC 税号', type: 'input', required: true, group: 'extParam', placeholder: 'XAXX010101000', tip: 'tipRfc' },
        { name: 'numericRef', label: '数字参考号', type: 'input', group: 'extParam', placeholder: 'max 7 digits', tip: 'tipNumericRef' },
        { name: 'notesRef', label: '备注', type: 'input', group: 'extParam', placeholder: 'max 40 chars', tip: 'tipNotesRef' },
      ],
      INSWITCH: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额(BRL)', type: 'input', required: true, tip: 'tipInswitchWithdrawAmount' },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['PIX_CODE'], tip: 'tipInswitchWithdrawMethod' },
        { name: 'callbackUrl', label: '回调地址', type: 'input', required: true, default: 'https://merchant.com/callback', tip: 'tipInswitchCallbackUrl' },
        { name: 'documentType', label: '证件类型', type: 'select', required: true, group: 'extParam', options: ['CPF', 'CNPJ'], tip: 'tipInswitchIdType' },
        { name: 'documentNumber', label: '证件号', type: 'input', required: true, group: 'extParam', placeholder: 'CPF: 11位纯数字 / CNPJ: 14位纯数字', tip: 'tipInswitchDocNumber' },
        { name: 'pixKey', label: 'PIX Key', type: 'input', required: true, group: 'extParam', placeholder: 'email / CPF / phone / UUID random key', tip: 'tipInswitchPixKey' },
        { name: 'firstName', label: '收款人名', type: 'input', required: true, group: 'extParam', tip: 'tipInswitchNameRule' },
        { name: 'lastName', label: '收款人姓', type: 'input', required: true, group: 'extParam', tip: 'tipInswitchNameRule' },
      ],
      TAZAPAY: [
        { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
        { name: 'amount', label: '金额', type: 'input', required: true },
        { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER'], tip: 'Tazapay 仅支持 BANK_TRANSFER' },
        { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
        { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam', tip: '绑卡返回的 recipientId' },
        { name: 'userId', label: 'User ID', type: 'input', required: true, group: 'extParam', tip: '创建用户返回的 userId' },
        { name: 'type', label: '转账方式', type: 'select', required: true, group: 'extParam', options: ['swift', 'local'], tip: 'swift 或 local' },
        { name: 'purpose', label: '用途代码', type: 'select', required: true, group: 'extParam', options: ['PYR001','PYR002','PYR003','PYR004','PYR005','PYR006','PYR007','PYR008','PYR009','PYR010','PYR011','PYR012','PYR013','PYR014','PYR015','PYR016','PYR017','PYR018','PYR019','PYR020','PYR021','PYR022','PYR023','PYR024','PYR025','PYR026','PYR027','PYR028','PYR029','PYR030','PYR031','PYR032','PYR033','PYR034'], tip: 'Tazapay 用途代码 PYR001~PYR034' },
        { name: 'transactionDescription', label: '交易描述', type: 'input', required: true, group: 'extParam', placeholder: 'Payout for services' },
        { name: 'originalAmount', label: '原始金额', type: 'input', required: true, group: 'extParam', tip: '非换汇场景与 amount 一致' },
        { name: 'originalCurrency', label: '原始币种', type: 'input', required: true, group: 'extParam', tip: '非换汇场景与 currency 一致' },
        { name: 'rateId', label: 'Rate ID (换汇)', type: 'input', group: 'extParam', tip: '换汇场景必填，对应 Tazapay quote' },
        { name: 'routeType', label: '出金网络', type: 'input', group: 'extParam', tip: '如 fedach / fedwire，local 时可选' },
        { name: 'documents', label: '附加文档', type: 'documentList', group: 'extParam', tip: '非必填，可添加多个文档（type/url/name）' },
      ],
    },
    fields: [
      { name: 'externalOrderId', label: '外部订单ID', type: 'input', required: true },
      { name: 'amount', label: '金额', type: 'input', required: true },
      { name: 'withdrawMethod', label: '提现方式', type: 'select', required: true, options: ['BANK_TRANSFER', 'PIX_CODE', 'INTERAC', 'EFT', 'LINKAJA', 'OVO', 'GOPAY', 'DANA', 'SHOPEEPAY'] },
      { name: 'callbackUrl', label: '回调地址', type: 'input', default: 'https://merchant.com/callback' },
      { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true, group: 'extParam' },
    ]
  },
  CARD_BIND: {
    label: '绑定银行账户',
    channelSpecific: true,
    channels: {
      EQUALS_MONEY: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'], group: 'extParam' },
        { name: 'bic', label: 'BIC/SWIFT', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam' },
        { name: 'bankName', label: '银行名称', type: 'input', required: true, group: 'extParam' },
        { name: 'purpose', label: '用途', type: 'select', options: ['SALARY', 'INVESTMENT', 'BUSINESS'], group: 'extParam' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'US' },
      ],
      SGB: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam' },
        { name: 'bankName', label: '银行名称', type: 'input', required: true, group: 'extParam' },
        { name: 'bic', label: 'BIC/SWIFT', type: 'input', group: 'extParam' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'SG' },
      ],
      LEAN_TECH: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号/IBAN', type: 'input', required: true, group: 'extParam', placeholder: 'AE070331234567890123456' },
        { name: 'bankIdentifier', label: '银行标识', type: 'input', required: true, group: 'extParam', placeholder: 'BANK123456' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'AE' },
      ],
      KORAPAY: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam', placeholder: '1234567890' },
        { name: 'bankIdentifier', label: '银行代码', type: 'input', required: true, group: 'extParam', placeholder: '000', tip: 'tipBankIdentifierFromList' },
        { name: 'bankName', label: '银行名称', type: 'input', group: 'extParam' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'NG' },
      ],
      DURIANPAY: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam', placeholder: '1234567890' },
        { name: 'bankIdentifier', label: '银行代码', type: 'select', required: true, group: 'extParam', options: ['BRI', 'BCA', 'MANDIRI', 'PERMATA', 'CIMB', 'BNI'] },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'ID' },
      ],
      BANK_FRICK: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号/IBAN', type: 'input', required: true, group: 'extParam', placeholder: 'LI21088100002324013AA' },
        { name: 'bic', label: 'BIC/SWIFT', type: 'input', required: true, group: 'extParam', placeholder: 'BFRILI22XXX' },
        { name: 'bankName', label: '银行名称', type: 'input', group: 'extParam' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'LI' },
      ],
      BANKING_CIRCLE: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号/IBAN', type: 'input', required: true, group: 'extParam', placeholder: 'GB29NWBK60161331926819' },
        { name: 'bic', label: 'BIC/SWIFT', type: 'input', group: 'extParam', placeholder: 'BCIRLULLXXX' },
        { name: 'bankName', label: '银行名称', type: 'input', group: 'extParam' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'GB' },
      ],
      PAGSMILE: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam', placeholder: '12345678901234' },
        { name: 'bankIdentifier', label: '银行代码', type: 'input', required: true, group: 'extParam', placeholder: '001', tip: 'tipPixKeyOrBankCode' },
        { name: 'accountType', label: '账户类型', type: 'select', group: 'extParam', options: ['CHECKING', 'SAVINGS'] },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'BR' },
      ],
      PYVIO: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: 'PIX Key', type: 'input', required: true, group: 'extParam', placeholder: 'email@example.com or CPF' },
        { name: 'pixKeyType', label: 'PIX Key类型', type: 'select', required: true, group: 'extParam', options: ['EMAIL', 'CPF', 'CNPJ', 'PHONE', 'RANDOM'] },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'BR' },
      ],
      PALMPAY: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名', type: 'input', required: true, group: 'extParam' },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, group: 'extParam', placeholder: '1234567890' },
        { name: 'bankIdentifier', label: '银行代码', type: 'input', required: true, group: 'extParam', placeholder: '000' },
        { name: 'bankCountry', label: '银行国家', type: 'input', group: 'extParam', placeholder: 'NG' },
      ],
      BITSO: [
        { name: 'accountId', label: '账户ID', type: 'input', required: true },
        { name: 'accountName', label: '账户名/收款人姓名', type: 'input', required: true },
        { name: 'accountNumber', label: '账号', type: 'input', required: true, placeholder: 'CLABE / debit card no. / phone no.' },
        { name: 'userType', label: '用户类型', type: 'select', required: true, options: ['INDIVIDUAL', 'BUSINESS'] },
        { name: 'clabe', label: 'CLABE号', type: 'input', required: true, group: 'extParam', placeholder: '18-digit number', tip: 'tipClabe' },
        { name: 'protocol', label: '协议类型', type: 'select', group: 'extParam', options: ['clabe', 'debitcard', 'phonenum'], tip: 'tipProtocol' },
        { name: 'bankCode', label: '银行代码', type: 'input', group: 'extParam', placeholder: 'e.g. 40012', tip: 'tipBankCodeDebitcard' },
      ],
    },
    fields: []
  },
  QUERY: {
    label: '账户查询',
    fields: [
      { name: 'accountId', label: '账户ID', type: 'input', required: true },
    ]
  },
  CARD_QUERY: {
    label: '银行账户信息查询',
    fields: [
      { name: 'recipientId', label: 'Recipient ID', type: 'input', required: true },
    ]
  }
};

// 生成充值外部订单ID: EXT_ORD_DEPOSIT_渠道缩写_2位递增
export const generatePayinOrderId = (channelCode) => {
  const channelMap = {
    'SGB': 'SG',
    'PAGSMILE': 'PS', 
    'PYVIO': 'PV',
    'LEAN_TECH': 'LT',
    'PALMPAY': 'PP',
    'KORAPAY': 'KP',
    'DURIANPAY': 'DP',
    'INSWITCH': 'IW',
    'CHECKOUT': 'CK'
  };
  const shortCode = channelMap[channelCode] || channelCode.substring(0, 2);
  const key = `payin_seq_${channelCode}`;
  const seq = (parseInt(sessionStorage.getItem(key) || '0') + 1);
  sessionStorage.setItem(key, seq.toString());
  return `EXT_ORD_DEPOSIT_${shortCode}_${String(seq).padStart(2, '0')}`;
};

// 生成提现外部订单ID: EXT_ORD_WITHDRAW_渠道缩写_2位递增
export const generateWithdrawOrderId = (channelCode) => {
  const channelMap = {
    'SGB': 'SG',
    'EQUALS_MONEY': 'EM',
    'BANKING_CIRCLE': 'BC',
    'KORAPAY': 'KP',
    'LEAN_TECH': 'LT',
    'PYVIO': 'PV',
    'BANK_FRICK': 'BF',
    'DURIANPAY': 'DP',
    'INSWITCH': 'IW'
  };
  const shortCode = channelMap[channelCode] || channelCode.substring(0, 2);
  const key = `withdraw_seq_${channelCode}`;
  const seq = (parseInt(sessionStorage.getItem(key) || '0') + 1);
  sessionStorage.setItem(key, seq.toString());
  return `EXT_ORD_WITHDRAW_${shortCode}_${String(seq).padStart(2, '0')}`;
};

// 生成提现外部订单ID: T+_渠道_YYYYMMDD_3位递增
export const generatePayoutOrderId = (channelCode) => {
  const now = new Date();
  const date = now.getFullYear().toString() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0');
  const key = `payout_seq_${channelCode}_${date}`;
  const seq = (parseInt(sessionStorage.getItem(key) || '0') + 1);
  sessionStorage.setItem(key, seq.toString());
  return `T+_${channelCode}_${date}_${String(seq).padStart(3, '0')}`;
};

// 构建请求体
export const buildRequestBody = (testType, formValues, channelCode, currency) => {
  console.log('buildRequestBody called:', { testType, channelCode, currency, formValues });
  
  const template = testTemplates[testType];
  if (!template) {
    console.error('Template not found for testType:', testType);
    return {};
  }

  const body = { 
    requestId: `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    channelCode, 
    currency,
    externalUserId: localStorage.getItem('uid') || localStorage.getItem('username')
  };
  const extParam = {};

  // 获取字段配置（渠道特定或通用）
  let fields = template.fields;
  if (template.channelSpecific && template.channels && template.channels[channelCode]) {
    fields = template.channels[channelCode];
    console.log('Using channel-specific fields for', channelCode, ':', fields);
  } else {
    console.log('Using generic fields:', fields);
  }

  if (!fields || fields.length === 0) {
    console.warn('No fields found for testType:', testType, 'channelCode:', channelCode);
  }

  fields.forEach(field => {
    // 跳过 externalUserId 字段，因为已经自动设置
    if (field.name === 'externalUserId') {
      return;
    }
    
    const value = formValues[field.name];
    console.log(`Field ${field.name}:`, value);
    if (value !== undefined && value !== '') {
      if (field.group === 'extParam') {
        // documentList: filter out incomplete entries
        if (field.type === 'documentList' && Array.isArray(value)) {
          const validDocs = value.filter(d => d && d.type && d.url && d.name);
          if (validDocs.length > 0) {
            extParam[field.name] = validDocs;
          }
        } else {
          extParam[field.name] = value;
        }
      } else {
        body[field.name] = value;
      }
    }
  });

  if (Object.keys(extParam).length > 0) {
    body.extParam = JSON.stringify(extParam); // 转换为JSON字符串
    console.log('extParam:', body.extParam);
  }

  console.log('Final request body:', body);
  return body;
};
